import { NewsletterPageSection } from "../../models/page-builder/newsletter-page-section.model";

export const MOCK_NEWSLETTER_SECTION: NewsletterPageSection = {
  type: "newsletter",
  content: {
    header: {
      title: "Sign up for our newsletter",
      titleColor: "#ffffff",
      subtitle:
        "Be the first to know about releases and industry news and insights.",
      subTitleColor: "#f1f1f1",
    },
    inputField: {
      placeholder: "Enter your email address",
      placeholderColor: "#6F8FAF",
      hintText: "We care about your data in our privacy policy.",
      hintTextColor: "#f1f1f1",
    },
    button: {
      label: "Subscribe",
      color: "#000000",
    },
    benefits: {
      show: true,
      items: [
        "Latest releases and tips",
        "New articles each week",
        "Exclusive content and more",
      ],
      icon: {
        enabled: true,
        svgName: "optionIcon-1",
        color: "#ffffff",
      },
    },
  },
  design: {
    layout: "card",
    appearance: {
      cardBackgroundColor: "#6F8FAF",
      backgroundColor: "#999999",
      backgroundImageUrl: {
        type: "image",
        originalFileName: "background-original.jpg",
        uploadFileName: "background.jpg",
        url: "https://picsum.photos/1406/400",
        imageSettings: {
          overlayWithBackground: true,
          opacity: 0.2,
          blending: "screen",
          blur: 3,
          grayScale: 10,
          contrast: 100,
        },
      },
    },
  },
};
